import React from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {isEnglish} from "../../../component/const/Function";

export const DataTable = ({data}) => {
    const location = useLocation();
    const navigate = useNavigate();
    if (!data || data.length === 0) return <h1 className={`text-4xl font-bold text-center`}>loading....</h1>;
    // 첫번째 객체의 key 목록에서 'age' 필드를 제외
    const headers = Object.keys(data[0]).filter((key) => !isEnglish(key));

    return (
        <div className="overflow-x-auto p-4 [&_tr]:">
            <table className="min-w-full table-auto border border-gray-200">
                <thead className="bg-gray-100">
                <tr>
                    {headers.map((header) => (
                        <th key={header} className="px-4 py-4 border text-xl"
                            dangerouslySetInnerHTML={{__html: header}}
                        />
                    ))}
                </tr>
                </thead>
                <tbody>
                {data.map((item, idx) => (
                    <tr key={idx} onClick={() => {
                        const resultArray = Object.entries(item)
                            .filter(([key]) => key.endsWith("_번호"))
                            .map(([key, value]) => ({
                                keyName: key,
                                id: value,
                            }));

                        navigate(location.pathname + "/detail", {state: {ids: resultArray}});
                    }}>
                        {headers.map((header) => (
                            <td className="px-4 py-4 border text-xl" key={`${header}${idx}`}
                                dangerouslySetInnerHTML={{__html: item[header] !== null ? item[header].toString() : ''}}/>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};
